import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { HelperProfileCard } from "./helper-profile-card";
import type { FlexHelper } from "@/lib/types";

interface HelperListProps {
  helpers: FlexHelper[];
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onAssign: (helperId: string) => void;
}

export function HelperList({ 
  helpers, 
  searchQuery, 
  onSearchChange,
  onAssign 
}: HelperListProps) {
  return (
    <div className="space-y-6">
      <div className="relative">
        <Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Search helpers by name or skills..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-9"
        />
      </div>

      <div className="space-y-4">
        {helpers.length === 0 ? (
          <div className="text-center py-12 text-muted-foreground">
            No helpers found matching your search.
          </div>
        ) : (
          helpers.map((helper) => (
            <HelperProfileCard
              key={helper.id}
              helper={helper}
              onAssign={onAssign}
            />
          ))
        )}
      </div>
    </div>
  );
}